import './styles/Layout.scss';

import React, { useEffect, useContext } from 'react';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { useCookies } from 'react-cookie';
import { FloatingFeedback } from './FloatingFeedback';
import { ServicesContext } from '@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/servicesContext';
import { Services } from '@sbi-international/boutik.gatsby.plugin.services/dist/src/common/interface/services';

interface ILayoutProps {
    children: any;
    bgColor?: string;
    config?: { mainPadding: string };
}

type LangCode = 'fr_CA' | 'en_CA' | 'en_US';

const rootPaths: Record<LangCode, string> = {
    fr_CA: '/ca/fr/',
    en_CA: '/ca/en/',
    en_US: '/us/en/',
};

export default function Layout(props: ILayoutProps) {
    const location = useLocation();
    const section = location.pathname;
    const [cookies, setCookies] = useCookies(['englander_store_lang']);

    const servicesContext = useContext(ServicesContext) as Services;

    useEffect(() => {
        if (!cookies?.englander_store_lang) {
            servicesContext.gatsby.geolocationService
                .getUserIPLocation()
                .then((response) => {
                    let langCode = 'fr_CA';
                    if (response?.country === 'CA') {
                        langCode = response.region === 'QC' ? 'fr_CA' : 'en_CA';
                    } else if (response?.country === 'US') {
                        langCode = 'en_US';
                    }
                    setCookies('englander_store_lang', langCode, {
                        path: '/',
                    });
                    redirectByCountry(langCode as LangCode);
                })
                .catch((e) => {
                    console.error('Error fetching the IP address:', e);
                });
        } else {
            checkCookieFromUrl(cookies?.englander_store_lang, section);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkCookieFromUrl = (langCode: LangCode, section: string) => {
        if (section.length >= 7) {
            if (section == '/ca/fr/' && langCode) {
                redirectByCountry(langCode);
            } else if (
                langCode == 'en_CA' &&
                (section.startsWith('/ca/fr/') || section.startsWith('/us/en/'))
            ) {
                clearCache();
                setCookieFromUrl(section);
            } else if (
                langCode == 'fr_CA' &&
                (section.startsWith('/ca/en/') || section.startsWith('/us/en/'))
            ) {
                clearCache();
                setCookieFromUrl(section);
            } else if (
                langCode == 'en_US' &&
                (section.startsWith('/ca/fr/') || section.startsWith('/ca/en/'))
            ) {
                clearCache();
                setCookieFromUrl(section);
            }
        }
    };

    const clearCache = () => {
        localStorage.clear();
        sessionStorage.clear();
    };

    const setCookieFromUrl = (section: string) => {
        if (section.startsWith('/ca/en/')) {
            setCookies('englander_store_lang', 'en_CA' as LangCode, {
                path: '/',
            });
        }
        if (section.startsWith('/ca/fr/')) {
            setCookies('englander_store_lang', 'fr_CA' as LangCode, {
                path: '/',
            });
        }
        if (section.startsWith('/us/en/')) {
            setCookies('englander_store_lang', 'en_US' as LangCode, {
                path: '/',
            });
        }
    };

    const redirectByCountry = (langCode: LangCode) => {
        if (
            Object.values(rootPaths).includes(section) &&
            rootPaths[langCode] !== section
        ) {
            navigate(rootPaths[langCode]);
        }
    };

    return (
        <>
            <main
                className={
                    props.config?.mainPadding
                        ? `p-${props.config.mainPadding}`
                        : 'p-default'
                }
                style={{
                    backgroundColor: props.bgColor,
                }}
            >
                {props.children}
            </main>
            <FloatingFeedback className='bottom feedback-alert' />
        </>
    );
}
